// Wrapper around jQuery ajax to handle token authentication.
// It must be API compatible with jQuery.

import $ from 'jquery'
import _ from 'lodash'

// Send request to update token cookie
var authenticate = function() {
  var xhrData = {
    dataType: 'json',
    method: 'POST',
    url: SOPHIA.Routes.user_sessions_path()
  };

  return $.ajax(xhrData);
};

// Call callback
var callback = _.rest(function(cbFn, args) {
  if (!cbFn) return;
  if (_.isArray(cbFn)) {
    cbFn.forEach(function(cb) { cb.apply(this, args) });
  } else {
    cbFn.apply(this, args);
  }
});

// Wrapper around jquery ajax to show preloader and handle authentication errors.
// Adds showPreloader option, false by default.
SOPHIA.ajax = function(options) {
  var showPreloader = !!options.showPreloader;

  if (showPreloader) SOPHIA.fancyboxShowActivity();

  return SOPHIA._ajax(options).always(function() {
    if (showPreloader) SOPHIA.fancyboxHideActivity();
  });
}

SOPHIA._ajax = function(options) {
  // Extract callbacks
  var callbackKeys = ['success', 'error', 'complete'];
  var callbacks = _.pick(options, callbackKeys);
  options = _.omit(options, callbackKeys);

  var deferred = $.Deferred();

  var success = function(data, status, xhr) {
    callback(callbacks.success, data, status, xhr);
    deferred.resolve(data, status, xhr);
    callback(callbacks.complete, xhr, status);
  };
  var error = function(xhr, status, error) {
    var fail = function() {
      callback(callbacks.error, xhr, status, error);
      deferred.reject(xhr, status, error);
      callback(callbacks.complete, xhr, status);
    };
    var retry = function() {
      $.ajax(options).then(success, fail);
    };

    if (403 == xhr.status || 401 == xhr.status) { // Forbidden or Unauthorized
      authenticate().then(retry, fail);
    } else {
      fail();
    }
  };
  $.ajax(options).then(success, error);

  return deferred.promise();
};
